import $ from "jquery";

$(function() {
    $('.js-has-sub').hover(function() {
		$(this).children('.l-header__sub').stop().slideDown();
	}, function() {
        $(this).children('.l-header__sub').stop().slideUp();
	});
});
